import { Institution } from "shared/institution";
import { Loadable, LoadableFactory } from "shared/loadable";

export type InstitutionState = Loadable<Institution>;

export const initialInstitutionState: InstitutionState =
  LoadableFactory.reset();
